/**
 * UserProfile — Avatar + dropdown dans le header
 * Affiche l'utilisateur connecté avec menu déroulant
 */

import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const CREW_ROLE_ICONS: Record<string, string> = {
  navigator: "🧭",
  cervelleau: "🧠",
  programmeur: "💻",
  securite: "🛡",
  createur: "🎨",
};

const ROLE_LABELS: Record<string, string> = {
  admin: "Administrateur",
  ops: "Opérations",
  viewer: "Observateur",
};

export default function UserProfile() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Hardcoded for now — will be dynamic when CF Access auth is wired
  const user = {
    name: "Jonathan",
    avatar: "J",
    role: "admin",
  };

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const menuItems = [
    { icon: "👤", label: "Profil", action: () => navigate("/settings") },
    { icon: "🎨", label: "Apparence", action: () => navigate("/settings") },
    { icon: "⚙", label: "Settings", action: () => navigate("/settings") },
  ];

  return (
    <div ref={ref} className="user-profile-wrap" style={{ position: "relative" }}>
      {/* Profile pill */}
      <div
        className="user-profile-pill"
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "4px 12px 4px 4px",
          borderRadius: "999px",
          background: open ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.04)",
          border: "1px solid var(--line)",
          cursor: "pointer",
          transition: "background 0.15s",
        }}
      >
        <div
          className="user-avatar"
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "999px",
            background: "linear-gradient(135deg, var(--purple), var(--blue))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: 700,
            color: "white",
            flexShrink: 0,
          }}
        >
          {user.avatar}
        </div>
        <span style={{ fontSize: "13px", fontWeight: 500 }}>{user.name}</span>
        <span style={{ fontSize: "10px", color: "var(--muted)", marginLeft: "2px" }}>▼</span>
      </div>

      {/* Dropdown */}
      {open && (
        <div
          className="user-profile-dropdown"
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "8px",
            width: "220px",
            borderRadius: "18px",
            border: "1px solid var(--line)",
            background: "rgba(18,22,41,0.98)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
            backdropFilter: "blur(10px)",
            zIndex: 1000,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "14px 16px",
              borderBottom: "1px solid var(--line)",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "999px",
                background: "linear-gradient(135deg, var(--purple), var(--blue))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "15px",
                fontWeight: 700,
                color: "white",
              }}
            >
              {user.avatar}
            </div>
            <div>
              <div style={{ fontSize: "14px", fontWeight: 600 }}>{user.name}</div>
              <div style={{ fontSize: "11px", color: "var(--muted)" }}>
                {ROLE_LABELS[user.role] || user.role}
              </div>
            </div>
          </div>

          {/* Menu items */}
          <div style={{ padding: "6px" }}>
            {menuItems.map((item) => (
              <div
                key={item.label}
                className="profile-menu-item"
                onClick={() => {
                  item.action();
                  setOpen(false);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 12px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  color: "#dce2eb",
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.06)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <span style={{ fontSize: "15px" }}>{item.icon}</span>
                {item.label}
              </div>
            ))}
          </div>

          {/* Logout */}
          <div style={{ borderTop: "1px solid var(--line)", padding: "6px" }}>
            <div
              className="profile-menu-item logout"
              onClick={() => {
                localStorage.removeItem("synapse_token");
                window.location.reload();
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 12px",
                borderRadius: "12px",
                fontSize: "13px",
                color: "var(--rust)",
                cursor: "pointer",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(207,107,98,0.08)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <span style={{ fontSize: "15px" }}>🚪</span>
              Déconnexion
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
